import React from 'react';
import { Routes, Route } from 'react-router-dom';

// IMPORTANT: this file is used ONLY by the prerender script (Node).
// We avoid React.lazy / Suspense here because vite-prerender-plugin relies on
// renderToString/renderToStaticMarkup which cannot handle suspended trees.

import Landing from './Landing';
import Tarifs from './Tarifs';
import FAQ from './FAQ';
import Contact from './Contact';
import MentionsLegales from './MentionsLegales';
import CGU from './CGU';
import Confidentialite from './Confidentialite';
import Cookies from './Cookies';
import Disclaimer from './Disclaimer';
import ProgrammaticPage from './ProgrammaticPage';
import { PROGRAMMATIC_PAGES } from '../lib/programmaticSeo.js';
import Login from './Login';
import Register from './Register';

export function AppRoutesPrerender() {
  return (
    <Routes>
      {/* Public / SEO */}
      <Route path="/" element={<Landing />} />
      <Route path="/tarifs" element={<Tarifs />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/mentionslegales" element={<MentionsLegales />} />
      <Route path="/cgu" element={<CGU />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/disclaimer" element={<Disclaimer />} />

      {PROGRAMMATIC_PAGES.map((page) => (
        <Route key={page.path} path={page.path} element={<ProgrammaticPage page={page} />} />
      ))}

      {/* Auth pages (kept prerender-safe; they are marked noindex in SEO config) */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Fallback */}
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
